import BookedIcon from 'src/components/svg/appointment/BookedIcon';

const index = {
  'booked-icon': BookedIcon
};

export default index;
